import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useState,useEffect } from "react";

function About_header(){

    const[Title,setTitle] = useState('');

    useEffect(() => {
        axios.get('https://panel.baghban.restaurant/api/header/about-us')
            .then(response => {
                setTitle(response.data.title);
                // setslideText(response.data.spotlites[0].text);
                //console.log(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    return(
        <div className="about-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>{Title}</h1>
                        <div className="breadcrumbs">
                            <Link to="/">صفحه اصلی</Link>
                            <i className="fas fa-angle-left"></i>
                            <span className="current-page">درباره ما</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default About_header;